import { addPermissionsToRoute } from '@qsrsoft/myq-core';
const routes = {
  name: 'Operations',
  icon: 'mdi-clipboard-text-outline',
  path: '/reports/shift',
  children: [
    {
      path: '/reports/shift/dailyActivity',
      name: 'Daily Activity Report',
      meta: { id: 'mc-dailyActivity', permission: 'dailyActivity' },
      component: () => import('./DailyActivityReport.vue'),
      ...addPermissionsToRoute(['dailyActivity']),
    },
    {
      path: '/reports/shift/opsReport',
      name: 'Operations Report',
      meta: { id: 'mc-opsReport', permission: 'opsReport' },
      component: () => import('./opsReport/OpsReportWrapper.vue'),
      ...addPermissionsToRoute(['opsReport']),
    },
  ],
};

export default routes;
